import React from 'react';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import useRiskNotesService from '../../useRiskNotesService';
import { CreateForm, FormFieldsData, FormTemplateProps } from 'framework/form';
import RiskNoteForm from '../RiskNoteForm';

interface CreateRiskUserNoteFormProps extends Omit<FormTemplateProps, 'children'> {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
  label?: string;
}

const CreateRiskUserNoteForm = ({ submitFormFunc, onCancel, label, ...props }: CreateRiskUserNoteFormProps) => {
  const { getNoteValidationSchema } = useRiskNotesService();
  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getNoteValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <RiskNoteForm label={label} />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateRiskUserNoteForm;
